<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="9">
        <v-row no-gutters>
          <v-col cols="4" sm="3" v-if="this.$route.name !== 'reschedule'">
            <v-text-field
              id="countryCode"
              class="input-field countrycode-input focused-border"
              outline
              height="48"
              :aria-label="messages.countryInputLabel"
              v-model="countryCode"
              :disabled="localReadOnly"
              :hide-details="true"
              type="tel"
              v-if="showAutocomplete"
              :aria-required="field.m === 1 ? true: false"
              :rules="countryCodeRules"
            >
              <div :for="countryCode" slot="label">{{field.m === 1 ? messages.countryInputLabel + ' *': messages.countryInputLabel}}</div>
            </v-text-field>
          </v-col>
          <v-col cols="8" sm="9">
            <v-text-field
              class="input-field phone-input focused-border"
              :append-icon="codeVerified? 'check' : ''"
              :rules="phoneRules"
              :id="field.name"
              outline
              height="48"
              :aria-label="label"
              v-model="mobileNumber"
              :disabled="localReadOnly"
              :hide-details="true"
              :aria-required="field.m === 1 || configuration.sendConfirm? true: false"
              type="tel"
              ref="phoneInput"
              @focus="phoneValidInitialised = true"
              :aria-describedby="phoneValidation"
            >
              <div :for="field.name" slot="label">{{field.m === 1 ? messages[field.name] +  ' *': messages[field.name]}}</div>
            </v-text-field>
            <span v-if="!isPhoneValid && phoneValidInitialised" class="hide-validation" id="phoneValidation" >{{ messages.phoneErrorAlert }}</span>
            <v-row v-if="!isPhoneValid && phoneValidInitialised">
              <v-col>
                <div role="alert" class="phoneErrorMessage v-text-field__details v-messages v-messages__message">{{phoneErrorMessage}}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn
          :ripple="false"
          v-if="!codeVerified && configuration.sendConfirm"
          :disabled="loading || !mobileNumber && !field.number || !isPhoneValid"
          text
          class="phone-verification-btn"
          @click="delay"
          ref="phoneCodeButton"
        >
          <div v-if="!loading">{{messages.contactDetailsContentMobileVerificationBtnText}}</div>
          <v-progress-circular role="progressbar" indeterminate color="white" v-else></v-progress-circular>
        </v-btn>
      </v-col>
      <v-dialog
        role="dialog"
        v-model="codeVerificationDialog"
        max-width="450"
        @keydown.esc="codeVerificationDialog=false"
        @keydown.enter="verifyCode"
      >
        <v-card>
          <v-card-title class="headline dialog-title">{{messages.verifyCodeTitle}}
            <v-spacer></v-spacer>
            <v-btn :ripple="false" icon @click.native="codeVerificationDialog = false">
              <v-icon color="white" :aria-label="messages.ariaCloseDialog">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              ref="codeInput"
              class="focused-border"
              outline
              autofocus
              height="48"
              autocomplete="off"
              :messages="showCounter"
              id="verification-code"
              v-model="userCodeInput"
              :error="codeVerificationRules.enabled"
              :error-messages="codeVerificationRules.errorMessage"
            >
              <div for="verification-code" slot="label">{{messages.verifyCodeDialogLabel}}</div>
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn id="sendCodeButton"
              :ripple="false"
              text
              class="cancel send-verification-btn"
              @click.native="delay"
              :disabled="isResendDisabled"
            >{{messages.sendVerificationCodeAgain}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :ripple="false"
              class="edit send-verification-btn"
              :disabled="!isPinOk"
              @click.native="verifyCode"
            >{{messages.verifyCodeButton}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import RestService from '../services/restService'
import { mapState, mapGetters } from 'vuex'
import { parsePhoneNumberFromString as parsePhone } from 'libphonenumber-js/max'
import json from '../assets/json/restcountries.json'

export default {
  name: 'PhoneField',
  props: [
    'field',
    'readOnly',
    'showAutocomplete',
    'showAppointments',
    'email',
    'services',
    'date',
    'time',
    'custRef',
    'branch',
    'phoneDetails'
  ],
  mixins: [RestService],
  data: () => ({
    localReadOnly: null,
    loading: false,
    regexPhone: '',
    selectedCountry: {},
    isLoading: false,
    search: null,
    allCountries: [],
    itemText: 'name',
    items: [],
    label: '',
    phoneValidation: 'phoneValidation',
    phoneRules: [],
    countryCodeRules: [],
    codeVerificationRules: {
      enabled: false,
      errorMessage: []
    },
    mobileNumber: '',
    countryCode: '',
    formattedPhone: '',
    codeVerificationDialog: false,
    codeVerified: false,
    codeSent: false,
    userCodeInput: null,
    existingAppointments: [],
    phoneErrorMessage: '',
    phoneValidInitialised: false,
    restcountries: json
  }),
  watch: {
    readOnly () {
      if (!this.readOnly) {
        // if parent readOnly prop is false, reset localReadOnly and country code
        this.localReadOnly = false
        if (this.defaultCountryPrefix === null || this.defaultCountryPrefix === undefined) {
          // The new setting phoneCountryCode has not been saved on the languages yet, so we get the default one like previously from the restcountries, but from the json file not rest call
          for (var i = 0; i < this.restcountries.length; i++) {
            if (this.restcountries[i].alpha2Code === this.selectedLanguage.countryCodeCountry.toUpperCase()) {
              this.countryCode = this.restcountries[i].callingCodes[0]
              break
            }
          }
        } else {
          this.countryCode = this.defaultCountryPrefix
        }
      }
    },
    mobileNumber () {
      if (this.funcDebug) console.log('PhoneField:watch:mobileNumber')
      this.mobileNumber = this.mobileNumber.replaceAll(' ', '')
      this.pushFormattedPhone()
    },
    countryCode () {
      if (this.funcDebug) console.log('PhoneField:watch:countryCode')
      if (typeof this.countryCode !== 'undefined') {
        if (this.countryCode.charAt(0) === '0') { this.countryCode = this.countryCode.substr(1) }
        if (this.countryCode.charAt(0) === '0') { this.countryCode = this.countryCode.substr(1) }
        if (this.countryCode.charAt(0) !== '+') { this.countryCode = '+' + this.countryCode }
        this.countryCode = this.countryCode.replace(' ', '')
        this.pushFormattedPhone()
      }
    },
    codeVerificationDialog () {
      // check that phone verified and dialog closed
      if (!this.codeVerified && !this.codeVerificationDialog) {
        // if only dialog closed, put focus back to input
        this.$nextTick(() => { this.$refs.phoneInput.focus() })
      }
    }
  },
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'funcDebug',
      'defaultCountryPrefix',
      'selectedLanguage'
    ]),
    ...mapGetters({
      getSecurityToken: 'getSecurityToken'
    }),
    isPinOk () {
      return this.userCodeInput != null && this.userCodeInput.length === parseInt(this.configuration.confirmDigits)
    },
    showCounter () {
      var counter = ''
      if (this.userCodeInput == null) { counter += '0/' } else { counter += this.userCodeInput.length + '/' }
      counter += this.configuration.confirmDigits
      return counter
    },
    isResendDisabled () {
      return this.codeSent
    },
    internationalPhone () {
      if (this.$route.name === 'reschedule') {
        const strippedPhoneNumber = '+' + this.mobileNumber
        return strippedPhoneNumber
      } else {
        const strippedPhoneNumber = this.mobileNumber.replace(/^0+/, '')
        return this.countryCode + strippedPhoneNumber
      }
    },
    isPhoneValid () {
      if (this.funcDebug) console.log('PhoneField:computed:isPhoneValid')
      if (typeof this.mobileNumber === 'undefined') {
        return false
      }
      let result = false
      if ((this.field.m === 1 || this.sendConfirm) && this.mobileNumber.length === 0) {
        // mandatory or sendConfirm AND length > 0
        result = false
      } else {
        if (this.mobileNumber.length > 0) {
          if (this.mobileNumber.charAt(0) !== '+') {
            if (this.configuration.usePhoneLib && this.configuration.usePhoneLib === true) {
              let testPhone = null
              testPhone = parsePhone(this.internationalPhone)
              // if undefined, then not recognized then invalid
              if (testPhone) {
                result = testPhone.isValid()
              }
            } else {
              result = this.regexPhone.test(this.internationalPhone)
            }
          }
        } else {
          if (this.field.m === 0 && !this.sendConfirm) {
            // not mandatory and not sendConfirm and length = 0
            result = true
          }
        }
      }
      this.setValidMessage(result)
      this.$emit('temp-phone', { countryCode: this.countryCode, phone: this.mobileNumber, verified: this.codeVerified })
      this.$emit('is-phone-valid', result)
      return result
    }
  },
  methods: {
    setValidMessage (result) {
      if (this.funcDebug) console.log('PhoneField:method:setValidMessage')
      if (result) {
        this.phoneErrorMessage = ''
      } else {
        if ((this.field.m === 1 || this.configuration.sendConfirm) && this.mobileNumber.length === 0) {
          this.phoneErrorMessage = this.messages.fieldRequired
        } else {
          this.phoneErrorMessage = this.messages.invalidPhone
        }
      }
    },

    pushFormattedPhone () {
      if (this.funcDebug) console.log('PhoneField:method:pushFormattedPhone')
      // check it do not send phone when only countryCode
      if (this.isPhoneValid && !this.configuration.sendConfirm) {
        if (this.mobileNumber.length === 0) {
          // phonevalid but no mobile, we don't want to send just the countrycode
          // but we want to send because be want to reset a preceding valid number that was send before
          this.formattedPhone = ''
        } else {
          this.formattedPhone = this.internationalPhone.substr(1) // remove +
        }
        if (this.funcDebug) console.log('Emit (phone-verified): ' + this.formattedPhone)
        this.$emit(
          'phone-verified',
          true,
          this.formattedPhone,
          this.mobileNumber,
          null,
          false
        )
      }
    },
    delay () {
      this.codeSent = true

      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.codeSent = false
      }, 5000)
      this.sendCode()
    },
    beforeDestroy () {
      // clear the timeout before the component is destroyed
      clearTimeout(this.timeout)
    },
    sendCode () {
      if (this.funcDebug) console.log('PhoneField:method:sendCode')
      this.loading = true

      var _this = this
      this.codeVerificationRules.enabled = false
      this.userCodeInput = null
      this.codeVerificationRules.errorMessage = []
      if (!this.localReadOnly) {
        this.formattedPhone = this.internationalPhone.substr(1)
      } else {
        this.formattedPhone = this.field.number
      }
      this.sendVerificationCode(this.formattedPhone, this.selectedLanguage, this.getSecurityToken).then(response => {
        if (response.data.message === 'error.verify.too.many') {
          _this.codeVerificationRules.errorMessage = _this.messages.verificationCodeTooMany
        }
        if (response.data.message === 'ERROR_SESSION_VIOLATION') {
          _this.codeVerificationRules.errorMessage = _this.messages.verificationCodeSessionValidation
        }
        _this.codeVerificationDialog = true
        _this.$nextTick(() => {
          _this.$refs.codeInput.$refs.input.focus()
        })
        _this.loading = false
      })
    },
    verifyCode () {
      if (this.funcDebug) console.log('PhoneField:method:verifyCode')
      var _this = this
      this.verifyPhoneNumber(this.userCodeInput, this.formattedPhone, this.getSecurityToken).then(
        response => {
          if (response.status === 200 && response.data.message === 'ok') {
            _this.codeVerificationDialog = false
            _this.codeVerified = true
            _this.localReadOnly = true
            if (_this.funcDebug) console.log('Emit (phone-verified): ' + _this.formattedPhone)
            _this.$emit(
              'phone-verified',
              _this.codeVerified,
              _this.formattedPhone,
              _this.mobileNumber,
              null,
              _this.localReadOnly
            )
            this.$emit('temp-phone', { countryCode: this.countryCode, phone: this.mobileNumber, verified: this.codeVerified })
            // }
          } else {
            _this.codeVerificationRules.enabled = true
            _this.codeVerificationRules.errorMessage = _this.messages.verificationCodeError
          }
        }).catch(error => {
        _this.codeVerificationRules.errorMessage = error.response.status + ' error - ' + error.response.statusText
      })
    },
    findByRef (array, attr) {
      // if object contains a phoneInput key
      var keys = Object.keys(array)
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === attr) {
          return true
        }
      }
      return false
    }
  },
  mounted () {
    if (this.funcDebug) console.log('PhoneField:mounted')
    this.localReadOnly = this.readOnly

    // set phone details if previously added in contact details
    if (typeof this.phoneDetails !== 'undefined') {
      this.countryCode = this.phoneDetails.countryCode ? this.phoneDetails.countryCode : ''
      this.mobileNumber = this.phoneDetails.phone ? this.phoneDetails.phone : ''
      this.codeVerified = this.phoneDetails.verified ? this.phoneDetails.verified : false
    }

    if (!this.localReadOnly) {
      if (!this.countryCode && (this.defaultCountryPrefix === null || this.defaultCountryPrefix === undefined)) {
        // The new setting phoneCountryCode has not been saved on the languages yet, so we get the default one like previously from the restcountries, but from the json file not rest call
        for (var i = 0; i < this.restcountries.length; i++) {
          if (this.restcountries[i].alpha2Code === this.selectedLanguage.countryCodeCountry.toUpperCase()) {
            this.countryCode = this.restcountries[i].callingCodes[0]
            break
          }
        }
      } else {
        this.countryCode = this.countryCode ? this.countryCode : this.defaultCountryPrefix
      }
      this.label = this.messages[this.field.name]
      this.regexPhone = new RegExp(this.configuration.regexPhone)
    } else {
      this.label = '+' + this.field.number
      this.mobileNumber = this.field.number ? this.field.number : this.mobileNumber
    }
  }
}
</script>
<style lang="scss" scoped>
  .container {
    padding: 0 24px;
    .row {
      margin-bottom: 8px;
    }
    .col {
      padding: 0 12px;
    }
  }
  .hide-validation {
    display: none;
  }
  @media screen and (min-width: 600px) {
    .v-input.input-field.v-text-field.phone-input{
      width: 95% !important;
    }

    .booking-container {
      .v-input.input-field.v-text-field.phone-input{
        width: 100% !important;
      }
    }
  }
  @media screen and (max-width: 480px) {
    .container {
      padding: 0 16px !important;
    }
    .countrycode-input {
      padding: 0 16px 0 0 !important;
      @at-root [dir="rtl"] & {
        padding: 0 0 0 16px !important;
      }
    }
    .phone-input {
      padding: 0 !important;
    }
    .phone-verification-btn {
      margin-left: 0 !important;
      margin: 8px 0 !important;
    }

    .phoneErrorMessage {
      margin: 8px 0;
    }
  }
</style>
